import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$translateProvider',
  function (runtimeConstant, $translateProvider) {
    function run() {
      try {
        $translateProvider.registerAvailableLanguageKeys(['pt-br'], {
          pt_BR: 'pt-br',
        });

        $translateProvider.useStaticFilesLoader({
          prefix: '/assets/languages/',
          suffix: '.json',
        });

        $translateProvider.preferredLanguage('pt_BR');
        $translateProvider.useSanitizeValueStrategy(null);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
